import { useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import print from "../../../Enums/Print";
import ReportsService from "../../../../services/ReportsService";
import Pagination from "../Pagination/Pagination";
import Select from "react-select";
import { ExportExcel } from "../../../Enums/Export";

const PaymentReport = () => {
	const [data, setData] = useState([]);
	const [payment, setPayment] = useState("");
	const [hasData, setHasData] = useState(null);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const reportsService = new ReportsService();
	const search = useSelector((state) => state.auth.search);
	const paymentOptions = [
		{ label: "Knet", value: "knet" },
		{ label: "CC", value: "cc" },
		{ label: "Samsung Pay", value: "samsung-pay" },
		{ label: "Apple Pay", value: "apple-pay" },
		{ label: "Google Pay", value: "google-pay" },
		{ label: "Cash", value: "cash" },
	];

	const printPage = () => {
		let headRow = [
			Translate[lang].payment_method,
			Translate[lang].usage_count,
			Translate[lang].percentage,
		];
		let dataInfo = data?.map((res) => {
			let info = {
				payment_method: res?.payment_method,
				usageCount: res.usageCount,
				percentage: res.percentage,
			};
			return info;
		});
		print("Payment Method", headRow, lang, dataInfo);
	};

	return (
		<>
			<div className="d-flex justify-content-between mb-4 align-items-center">
				<span
					style={{
						fontWeight: "600",
						textTransform: "capitalize",
						color: "#000",
					}}>
					{Translate[lang].payment}
				</span>
				<div className="d-flex gap-8">
					<Button variant="outline-primary" onClick={() => ExportExcel(data)}>
						<i className="las la-download fs-20" /> {Translate[lang].export}
					</Button>
					<Button variant="primary" onClick={() => printPage()}>
						<i className="las la-print fs-20" /> {Translate[lang].print}
					</Button>
				</div>
			</div>
			<div className="row mb-4">
				<div className="col-6">
					<label>{Translate[lang].payment_method}</label>
					<Select
						options={paymentOptions}
						value={payment}
						onChange={(e) => setPayment(e)}
					/>
				</div>
				<div className="col-6">
					<div className="d-flex h-100 gap-8 align-items-end">
						<Button
							variant="outline-primary"
							className="w-100"
							onClick={() => setShouldUpdate((prev) => !prev)}>
							{Translate[lang].apply}
						</Button>
						{!!payment && (
							<Button
								variant="outline-danger"
								className="w-100"
								onClick={() => {
									setPayment("");
									setShouldUpdate((prev) => !prev);
								}}>
								{Translate[lang].clear_filter}
							</Button>
						)}
					</div>
				</div>
			</div>
			<div>
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr className="text-center">
									<th>
										<strong>{Translate[lang].payment_method}</strong>
									</th>
									<th>
										<strong>{Translate[lang].usage_count}</strong>
									</th>
									<th>
										<strong>{Translate[lang].percentage}</strong>
									</th>
								</tr>
							</thead>

							<tbody className="table-body">
								{data?.map((item, index) => {
									return (
										<tr key={index} className="text-center">
											<td className="text-wrap-mode">{item.payment_method}</td>
											<td>{item.usageCount}</td>
											<td>{item.percentage}</td>
										</tr>
									);
								})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && !loading && <NoData />}
					<Pagination
						setData={setData}
						service={reportsService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
						param={
							!!payment?.value
								? {
										payment_method: payment?.value,
								  }
								: ""
						}
						type="paymentReport"
					/>
				</div>
			</div>
		</>
	);
};

export default PaymentReport;
